import React from "react";
import FormattedDate from './FormattedDate';
import WeatherIcon from './WeatherIcon';
import WeatherTemperature from './WeatherTemperature';


export default function WeatherInfo (props){
    return(<div class="row">
    <div class="col-4">
  <h1 id="city">{props.data.city}</h1>
  <h3 className="last-updated">Last updated:</h3>
  <FormattedDate date={props.data.date}/>
  </div>
  
  <div class="col-5">
    <ul> <li>
    <WeatherTemperature celsius={Math.round(props.data.temperature)}/>
        </li>
       
        <li className="text-capitalize" id="weather-description">{props.data.description}</li>
        <li id="humidity">Humidity: {props.data.humidity} %</li>
        <li id="wind">Wind: {Math.round(props.data.wind)} km/h</li>
        </ul>
      </div>
      <div class="col-3">
      <WeatherIcon code={props.data.icon} alt={props.data.description}/>
      </div>
      </div>)
}